import axios from 'axios';
import {
  all_information,
  GetBackendUrlForGlobalFunctions,
  loadingShow,
} from '../../App';
import {convertToDateInput, DependencyInfo, InlineEditOrderType} from '../Types/types';
import Message from '../Message/Message';
import { EditOperations } from '../../services/Operations/OperationServices';
import moment from 'moment';
export function adjustDates(operationData: any[], offset: number) {
  return operationData.map(({ plannedStartDate, plannedEndDate, planned_end_date,planned_start_date,...rest }) => ({
    ...rest,
    scheduled_start_date: new Date(new Date(rest.scheduled_start_date).getTime() + offset),
    scheduled_end_date: new Date(new Date(rest.scheduled_end_date).getTime() + offset),
  }));

}
export function getAdjustedDatas(datas: any[], type: string | undefined, offsetDiff: number, serverOffsetMillis : number): any[] {
  console.log("type: ",type)
  if (!type) {
    return adjustDates(datas, -serverOffsetMillis);
  }
  //
  // if (type === 'edit-button') {
  //     console.log("this.serverOffsetMillis: " + this.serverOffsetMillis/(6000 *60*10));
  //     const differenceOffsetMillis = this.serverOffsetMillis - this.localOffsetMillis;
  //     console.log("this.differenceOffsetMillis: " + differenceOffsetMillis/(6000 *60*10));
  //     console.log("this.localOffsetMillis: " + this.localOffsetMillis/(6000 *60*10));
  //     console.log("this.offsetDiff: " + offsetDiff/(6000 *60*10));
  //
  //     return this.adjustDates(datas, differenceOffsetMillis);
  // }
  // if (type === 'drag') {
  //     return this.adjustDates(datas,  0);
  // }
  console.log("offsetDiff 44444: ",offsetDiff/(6000*600))

  return adjustDates(datas, offsetDiff);
}
export function isInlineEditOrderDataEqual(
  object1: InlineEditOrderType,
  object2: InlineEditOrderType
) {
  let res: boolean = true;
  object1.priority_code !== object2.priority_code ? (res = false) : (res = res);
  object1.priority_id !== object2.priority_id ? (res = false) : (res = res);
  object1.asset_description !== object2.asset_description
    ? (res = false)
    : (res = res);
  object1.department_code !== object2.department_code
    ? (res = false)
    : (res = res);
  object1.department_id !== object2.department_id ? (res = false) : (res = res);
  object1.status_code !== object2.status_code ? (res = false) : (res = res);
  object1.status_id !== object2.status_id ? (res = false) : (res = res);
  object1.type_code !== object2.type_code ? (res = false) : (res = res);
  object1.type_id !== object2.type_id ? (res = false) : (res = res);
  object1.site_details_1 !== object2.site_details_1
    ? (res = false)
    : (res = res);
  object1.wo_labour_cost !== object2.wo_labour_cost
    ? (res = false)
    : (res = res);
  object1.wo_material_cost !== object2.wo_material_cost
    ? (res = false)
    : (res = res);
  object1.wo_other_cost !== object2.wo_other_cost ? (res = false) : (res = res);
  return res;
}

export const getLocalUtcOffSetValue = (): number => {
  const localUTCString = localStorage.getItem('tzDrawer');
  if (
    localUTCString != undefined &&
    localUTCString != '' &&
    localUTCString !== null
  ) {
    var index = localUTCString!.indexOf('+');
    if (index === -1) {
      index = localUTCString!.indexOf('-');
    }
    if (index !== -1) {
      var substringAfterePlusMinus = localUTCString!.substring(index);
      return parseInt(substringAfterePlusMinus) * 60;
    } else {
      return 0;
    }
  } else {
    return 0;
  }
};

export const getFilteredOrder = async (
  current_query: string | undefined,
  applyTheRule: any,
  section: string
) => {
  if (current_query !== undefined && current_query !== '') {
    let jsonString_current_query: string = current_query;
    if (section === 'planning-console-section') {
      let query = current_query.split('?');
      //jsonString_current_query = current_query.slice(0, -1);
      //jsonString_current_query = query[0];
      let plan_id = localStorage.getItem('cs_plan_dd_value');

      jsonString_current_query = `{"f":"plan_id","c":"=","t":"where","v":"${plan_id}"}`;
    }
    let jsonObject_current_query = JSON.parse(jsonString_current_query);
    if (jsonObject_current_query.f === 'plan_id') {
      jsonObject_current_query.f = 'ID';
    }
    jsonObject_current_query.t = 'andWhere';
    let init_query: string = JSON.stringify(jsonObject_current_query) + '?';
    let planner_query = await applyTheRule('uw_order', 'Cloud Planner');
    current_query = planner_query + init_query;
    let theUrl =
      GetBackendUrlForGlobalFunctions() +
      `order` +
      `/${0}?where=1$500$` +
      current_query;
    let theResult = await axios.get(theUrl);
    if (Array.isArray(theResult.data)) {
      theResult.data = theResult.data.map((item: any) => {
        // item.order_code varsa ve bir string ise trim uygulayın
        return { ...item, order_code: item?.order_code?.trim() };
      });
    }
    return theResult;
  }
};
export const stringToArray = (str: string): number[] => {
  let temp = [];
  temp = str.split(',');
  temp = temp.map((el) => parseInt(el));
  return temp;
};
export const extractNumbers = (text: string): string => {
  const regex = /\d+/g;
  const numbers = text.match(regex);
  return numbers ? numbers.join(',') : '';
};

export const extractStringValue = (jsonString: string): string => {
  const obj = JSON.parse(jsonString);
  const valuesString = JSON.stringify(obj);
  const regex = /"([^"]*)"/g;
  let match;
  const results: string[] = [];

  while ((match = regex.exec(valuesString)) !== null) {
    if (match[1] !== 'value') {
      results.push(match[1]);
    }
  }
  return results.length > 0 ? results[0] : '';
};

export const extractCharacters = (str: any): string[] => {
  if (str != null) {
    var parsed = JSON.parse(str);
    var characters = parsed.value.map(function (char: any) {
      return char.toString();
    });
    return characters;
  }
  return [];
};
export const convertToDate = (input: convertToDateInput) => {
  const { startDate, endDate, value } = input;
  // var value= value.map((dateString) => new Date(dateString)),
  const output = [new Date(startDate), new Date(endDate)];
  return output;
};

export const removeParentheses = (expression: string): string => {
  return expression.replace(/[()]/g, '');
};

export const SavePointEdit = async (dataInput: any): Promise<void> => {
  var updatedList: Object[] = [];
  if (!Array.isArray(dataInput)) {
    dataInput = [dataInput];
  }
  dataInput.map((data: any) => {
    if (data.label) {
      delete data.label;
      delete data.tradeDescription;
    }
    let duration = moment(new Date(data.scheduled_end_date)).diff(
      new Date(data.scheduled_start_date),
      'hours'
    );
    let the_end_date = data.scheduled_end_date;
    if (data.estHours !== null && data.required !== null) {
      var theDurationResult = Number(data.estHours) / Number(data.required);
      the_end_date = moment(new Date(data.scheduled_start_date))
        .add(theDurationResult, 'h')
        .toDate();
      duration = theDurationResult;
    }
    const first_obj: any = {
      ...data,
      organizationId: all_information.company_id?.toString(),
      createdBy: all_information.user_id,
      // required: parseFloat(data.required).toFixed(2),
      // estHours: parseFloat(data.estHours).toFixed(2),
      //i added toString()
      required: data.required?.toString(),
      estHours: data.estHours?.toString(),
      operationId: Number(data.operationId),
      qtyAssigned: '',
      duration: duration?.toString(),
      scheduled_end_date: new Date(the_end_date),
    };
    delete first_obj.materialStatus;
    updatedList.push(first_obj);
  });
  // if (first_obj.pm_id) {
  //       first_obj.operationSequence = getSecondNumber(
  //     first_obj.operationSequence
  //   );
  // } else {
  //   first_obj.operationSequence = data.operationSequence;
  // }

  //   if (first_obj.pm_id) {
  //   if (first_obj.operationSequence.includes(first_obj.pm_id)) {
  //       first_obj.operationSequence = getSecondNumber(
  //     first_obj.operationSequence
  //   );
  //   }
  //   else {
  //     first_obj.pm_id = null;
  //     first_obj.operationSequence = data.operationSequence;
  //   }

  // } else {
  //   first_obj.operationSequence = data.operationSequence;
  // }
  await EditOperations(updatedList, true)
    .then(() => {
      Message.success('Success');
      loadingShow(false);
    })
    .catch((err: any) => {
      if (err.response) {
        Message.error(
          err.response.data +
            '\n' +
            err.response.status +
            '\n' +
            err.response.headers
        );
      } else if (err.request) {
        Message.error(err.request);
      } else {
        Message.error('Error: ' + err.message);
      }
      loadingShow(false);
    });
};

export function parseDependencyCode(dependencyCode: string): DependencyInfo | null {
  const match = dependencyCode.match(/^(\d+)\s+(FS|SS|FF|SF)/);

  if (!match) return null;

  const [, operationId, dependencyType] = match;

  return {
    operationId,
    dependencyType: dependencyType as DependencyInfo['dependencyType']
  };
}


export function groupTasksByDate(tasks: any[]): Record<string, any[]> {
  const grouped: Record<string, any[]> = {};

  for (const task of tasks) {
    if (task.hasChildRecords === false) {
      const dateKey = formatDate(task.StartDate);
      if (!grouped[dateKey]) {
        grouped[dateKey] = [];
      }
      task.orderCode= task.taskData.orderCode;
      task.section= task.taskData.section;
      task.pm_schedule_id= task.pm_schedule_id;
      task.estHours= task.taskData.estHours;
      task.type_code= task.taskData.type_code;
      task.reason= task.taskData.reason;
      grouped[dateKey].push(task);
    }
    if (task.hasChildRecords === undefined) {
      const dateKey = task.StartDate !== undefined ? formatDate(task.StartDate) : task.scheduled_start_date;
      if (!grouped[dateKey]) {
        grouped[dateKey] = [];
      }
      // task.orderCode= task.taskData.orderCode;
      // task.section= task.taskData.section;
      // task.pm_schedule_id= task.pm_schedule_id;
      // task.estHours= task.taskData.estHours;
      // task.type_code= task.taskData.type_code;
      // task.reason= task.taskData.reason;
      grouped[dateKey].push(task);
    }
  }

  return grouped;
}
function formatDate(date: string | Date): string {
  const d = new Date(date);
  return d.toLocaleDateString('en-GB', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' });
}



export function transformToMultiTableFormat(groupedData: Record<string, any[]>): any[] {
  const result: any[] = [];
  for (const date in groupedData) {
    const tasks = groupedData[date];

    result.push({
      WorkOrderDescription: `### ${date.toUpperCase()} ###`,
      isHeader: true,
    });

    for (const task of tasks) {
      result.push({
        ...task,
        WorkOrderDescription: '',
        StartDate: task.StartDate !== undefined ? formatExcelDate2(task.StartDate) : formatExcelDate2(task.scheduled_start_date),
        EndDate: task.StartDate !== undefined ? formatExcelDate2(task.EndDate) : formatExcelDate2(task.scheduled_end_date),
      });
    }
    // const totalHours = tasks.reduce((sum, task) => {
    //   const estHours = Number(task.estHours);
    //   const required = Number(task.required);
    //   if (isNaN(estHours) || isNaN(required) || required === 0) {
    //     return sum;
    //   }
    //   return sum + estHours / required;
    // }, 0);

    const totalHours = tasks.reduce((sum, task) => {
      const estHours = Number(task.estHours);
      if (isNaN(estHours)) return sum;
      return sum + estHours;
    }, 0);

    result.push({
      WorkOrderDescription: `TOTAL HOURS FOR ${date.toUpperCase()}: ${totalHours}`,
      isFooter: true,
    });
    result.push({});
    result.push({});
  }

  return result;
}




function formatExcelDate(date: string | Date) {
  const d = new Date(date);
  return `${d.getDate().toString().padStart(2, '0')}.${(d.getMonth() + 1)
      .toString()
      .padStart(2, '0')}.${d.getFullYear()} ${d.getHours().toString().padStart(2, '0')}:${d
      .getMinutes()
      .toString()
      .padStart(2, '0')}`;
}

function formatExcelDate2(date: string | Date): string {
  const d = new Date(date);
  const day = d.getDate().toString().padStart(2, '0');
  const month = d.toLocaleString('en-US', { month: 'long' }).toUpperCase();
  const year = d.getFullYear();
  return `${day} ${month} ${year}`;
}

export const excelQueryCellInfo = (args: any) => {
  const data = args.data;

  if (!data || Object.keys(data).length === 0) {
    return;
  }

  const baseFontStyle = {
    fontName: 'Verdana',
    fontSize: 10,
    wrapText: true,
  };

  if (args.column?.field === 'WorkOrderDescription' && !data.isHeader && !data.isFooter) {
    args.cellValue = '';
    return;
  }

  if (data.isHeader) {
    args.style = {
      ...baseFontStyle,
      backColor: '#000000',
      fontColor: '#FFFFFF',
      bold: true,
    };
    return;
  }

  if (data.isFooter) {
    args.style = {
      ...baseFontStyle,
      backColor: '#FCE4D6',
      bold: true,
    };
    return;
  }

  if (['CC', 'HC', 'ST'].includes((data.site_details_1 || '').trim()) && args.column?.field === 'TaskName') {
    args.style = {
      ...baseFontStyle,
      backColor: '#FFFF00',
    };
    return;
  }

  if (data.pm_schedule_id == null && args.column?.field === 'TaskName') {
    args.style = {
      ...baseFontStyle,
      backColor: '#C6EFCE',
    };
    return;
  }

  if (data.pm_id != null && args.column?.field === 'TaskName') {
    args.style = {
      ...baseFontStyle,
      backColor: '#FFFF00',
    };
    return;
  }

  const dateStr = data.scheduled_start_date;
  if (dateStr) {
    const date = new Date(dateStr);
    const hour = date.getHours();

    if (!isNaN(hour)) {
      if (hour >= 6 && hour < 18) {
        args.style = {
          ...baseFontStyle,
          backColor: '#FFFFFF',
        };
      } else {
        args.style = {
          ...baseFontStyle,
          backColor: '#D9D9D9',
        };
      }
    }
  }
};

